:host {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--aha-sidepanel--pull-tab-width);
  height: var(--aha-sidepanel--pull-tab-width);
  font-size: 16px;
  cursor: pointer;
}
